import DualLabelSwitch from './DualLabelSwitch'

export default DualLabelSwitch
